import { Stack } from '@mui/material';
import styled from 'styled-components';

export const FeatureFlagItemContainer = styled(Stack)`
  && {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    padding: 1rem;
    border: 1px solid ${({ theme }) => theme.palette.stroke.secondaryLight};
    border-radius: ${({ theme }) => theme.shape.cardRadius};
    background-color: ${({ theme }) => theme.palette.background.paper};
  }
`;

export const FeatureFlagText = styled(Stack)`
  && {
    flex: 1;
    min-width: 0;
    gap: 0.25rem;
    overflow-wrap: anywhere;
  }
`;

export const FeatureFlagToggle = styled.div`
  flex-shrink: 0;
`;
